import {RandomUtils} from '@colonist/utils'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables'
import {StorageWrapper} from './StorageWrapper'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {ClientUserState} from './ClientUserState'
import {RankedConstants} from '../../../shared/GameEnums'
import {getReplayUrlSlug} from './ui_replay/ReplayUrlUtilities'

export module UserSessionUtils {

    export function canShowLoginPopup(): boolean {
        const isUserWatchingReplayShareableLink = getReplayUrlSlug(window.location.href) !== undefined
        if(isUserWatchingReplayShareableLink) return false
        if(UIUtilsEjsVariables.isUserOnDiscord) return false
        if(ClientUserState.userState?.isLoggedIn) return false
        if(ClientUserState.userState?.hasZeroCompletedGames()) return false
        if(RandomUtils.randomIntBetween(0, 1) === 0) return false
        // if(ClientUserState.userState.karmaCompletedGameCount < 1) return false
        return true
    }

    export function canShowDiscordKeepPlayingOnWebPopup(): boolean {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return false
        if(StorageWrapper.getDiscordKeepPlayingOnWebPopupShown() == true) return false

        const languagesEligibleForPopup = ['ru']
        return languagesEligibleForPopup.includes(UIUtilsEjsVariables.language)
    }

    export function canShowSubscriptionPopup(): boolean {
        if(UIUtilsEjsVariables.isUserOnDiscordMobile) return false
        if(ClientUserState.userState?.items.hasMembership()) return false
        if(ClientUserState.userState?.hasZeroCompletedGames()) return false
        return true
    }

    export function shouldShowChangeUsernamePopup(matchmakingMatchType: MatchmakingMatchTypes | undefined): boolean {
        if(UIUtilsEjsVariables.isUserOnDiscord == false) return false
        if((ClientUserState.userState?.usernameChangeAttemptsLeft ?? 0) < 1) return false
        if(StorageWrapper.getDiscordOnlineUsernamePopupShown() == true) return false
        if(matchmakingMatchType == undefined) return false
        return true
    }

    export function userEligibleForRanked(): boolean {
        return (ClientUserState.userState?.totalCompletedGameCount ?? 0) >= RankedConstants.NumberOfGamesToUnlockRanked
    }

    export function gamesLeftToUnlockRanked(): number {
        return RankedConstants.NumberOfGamesToUnlockRanked - (ClientUserState.userState?.totalCompletedGameCount ?? 0)
    }
}
